import ENDPOINTS from 'shared/api/endpoints';
import RequestClient from 'shared/api/http-client';

export type OngoingEventRaw = Record<string, any> & {
  event_timestamp?: number;
  end_timestamp?: number;
  cancelled?: boolean;
  week?: number;
};

export type OngoingEventComputed = OngoingEventRaw & {
  total_duration: number;
  end_padding: number;
  current_timestamp: number;
  end_time_left: number;
  has_ongoing: boolean;
};

export async function fetchOngoingEvent(params: {
  schedule_id: number | string;
}): Promise<OngoingEventComputed> {
  const { schedule_id } = params;

  const url = `${ENDPOINTS.SCHEDULE_LIVE}/${schedule_id}/live`;
  const res = await RequestClient.get(url);

  const status = res?.status;
  const data = res?.data;
  const hasNoContent =
    status === 204 ||
    data == null ||
    (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0);

  if (hasNoContent) {
    const current_timestamp = Math.floor(Date.now() / 1000);
    return {
      total_duration: 0,
      end_padding: 1,
      current_timestamp,
      end_time_left: 0,
      has_ongoing: false,
    } as OngoingEventComputed;
  }

  const raw: OngoingEventRaw = (data || {}) as any;
  const end_timestamp = Number(raw.end_timestamp || 0);
  const event_timestamp = Number(raw.event_timestamp || 0);

  const end_padding = 1;
  const total_duration = end_timestamp - event_timestamp;
  const current_timestamp = Math.floor(Date.now() / 1000);
  const end_time_left = (end_timestamp - end_padding) - current_timestamp;
  const has_ongoing = end_time_left > 0;

  return {
    ...raw,
    total_duration,
    end_padding,
    current_timestamp,
    end_time_left,
    has_ongoing,
  };
}

